module.exports = __webpack_public_path__ + "media/images/default/shared/header/main-375-ba97cc71e789edd7f5727ca95aca7765.jpg";